import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cdbc05a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"850px"} }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "openBox" }
const _hoisted_4 = { class: "openContent" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "operate"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "flex-ter" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "tipsBox openBox" }
const _hoisted_11 = { class: "openContent" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "tips" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"16px","height":"16px","vertical-align":"sub"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/restore_caution.svg",
  alt: ""
}, null, -1))
const _hoisted_15 = {
  class: "flex-ter",
  style: {"margin-top":"16px"}
}
const _hoisted_16 = { class: "zaitu" }
const _hoisted_17 = {
  class: "flex-end foot",
  style: {"margin-top":"24px"}
}

import { t } from '@/plugins/i18n'
import { CustomerShopOptDTO, CustomerShopRespDTO } from '@/service/customer'
import { request } from '@/config/request/interceptors'
import { onMounted, ref } from 'vue'
import store from '@/store'
import { ElMessage } from 'element-plus'

// 编辑信息

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const shopInfo = ref<CustomerShopOptDTO>({
  replenishTimeList: ['10:00'],
  smartReplenishFlag: 0,
  customerShopUseOnTheWayStockFlag: 0
})

// 获取配置
const getAutoOrder = async () => {
  const res = await request.customer.customer.shopGet({})
  shopInfo.value = {
    ...res.data,
    replenishTimeList: res.data?.replenishTimeList?.length ? res.data?.replenishTimeList : ['10:00']
  }
}

onMounted(async () => {
  getAutoOrder()
})

// 保存
const sureConfig = async () => {
  if (shopInfo.value.smartReplenishFlag) {
    if (shopInfo.value.replenishTimeList?.some(i => i === '')) {
      return ElMessage.error(t('请选择定时节点'))
    }
    if (shopInfo.value.replenishTimeList?.length === [...new Set(shopInfo.value.replenishTimeList)]?.length) {
      await request.customer.customer.shopAutoOrderSwitch({ replenishTimeList: shopInfo.value.replenishTimeList?.sort(), smartReplenishFlag: 1, customerShopId: store.getters.curShop, customerShopUseOnTheWayStockFlag: 1 })
    } else {
      return ElMessage.error(t('定时节点不能同一时间'))
    }
  } else {
    await request.customer.customer.shopAutoOrderSwitch({ customerShopUseOnTheWayStockFlag: shopInfo.value.customerShopUseOnTheWayStockFlag, smartReplenishFlag: 0, customerShopId: store.getters.curShop, replenishTimeList: shopInfo.value.replenishTimeList?.sort() })
  }
  ElMessage.success(t('保存成功'))
  getAutoOrder()
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_radio_group, {
        modelValue: shopInfo.value.smartReplenishFlag,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shopInfo.value.smartReplenishFlag) = $event)),
        class: "switch"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio, {
            name: "smartReplenishFlag",
            label: 1
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('开启')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                innerHTML: _unref(t)('集成采购计划功能上线后，系统将改变原有的逐单采购模式，转为按设定周期自动汇总需求。在指定时间段内生成的API订单将暂不下单，而是由系统整合为集合采购单，用户可对建议补货数量进行调整，以实现更精准的库存管控。该功能有助于企业稳定在库水平，提高订单履约时效，同时避免产生过高库存压力。用户只需设定好补货截止时间，系统将在该节点自动生成优化的采购计划，提升采购效率与库存健康度。')
              }, null, 8, _hoisted_5)
            ]),
            (shopInfo.value.smartReplenishFlag == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('定时节点')) + ":", 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_space, { class: "fx-1" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopInfo.value.replenishTimeList, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "rel",
                            key: index
                          }, [
                            _createVNode(_component_el_time_select, {
                              style: {"width":"100%"},
                              size: "large",
                              modelValue: shopInfo.value.replenishTimeList![index],
                              "onUpdate:modelValue": ($event: any) => ((shopInfo.value.replenishTimeList![index]) = $event),
                              start: "00:00",
                              step: "01:00",
                              end: "23:00",
                              placeholder: _unref(t)('请选择')
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                            (index > 0)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "deleteIcon",
                                  onClick: () => shopInfo.value.replenishTimeList?.splice(index, 1),
                                  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/restore_close.svg",
                                  alt: ""
                                }, null, 8, _hoisted_9))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    (shopInfo.value.replenishTimeList?.length != 3)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          size: "large",
                          round: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (shopInfo.value.replenishTimeList?.push(''))),
                          class: "btn-add"
                        }, _toDisplayString(_unref(t)('新增定时')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_radio, {
            name: "smartReplenishFlag",
            label: 0,
            style: {"margin-top":"32px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('关闭后，会为您更新一条补货计划，后续的订单将不计入到补货计划，API订单没有匹配到库存将自动走采购流程。')), 1),
        (shopInfo.value.smartReplenishFlag == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_unref(t)('您是否要关闭使用在途库存？关闭后则囤货单支付后不会自动匹配直发单，当囤货单商品采购完成上架后才可以匹配直发单。')), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('使用在途库存')) + "：", 1),
                _createVNode(_component_el_radio_group, {
                  modelValue: shopInfo.value.customerShopUseOnTheWayStockFlag,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shopInfo.value.customerShopUseOnTheWayStockFlag) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      name: "customerShopUseOnTheWayStockFlag",
                      label: 1
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('开启')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      name: "customerShopUseOnTheWayStockFlag",
                      label: 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_el_button, {
        size: "large",
        type: "primary",
        onClick: sureConfig
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})